import React, { useMemo } from 'react'
import 'react-lazy-load-image-component/src/effects/blur.css'

import { imageBaseURL } from '../../services/defaultProps'
import { withWindowSizeListener } from 'react-window-size-listener'
import { FiArrowLeft } from 'react-icons/fi'
import { useHistory, useLocation } from 'react-router-dom'
import '../../styles/containers/ImageCarousel.css'
import Carousel from '../../components/Carousel'

const ImageCarousel = props => {
  const location = useLocation()
  const history = useHistory()

  const photos = useMemo(() => location.state && location.state.photos.map(({ image, text }) => ({image: imageBaseURL + image, text})), [location.state])
  const initialPhoto = useMemo(() => location.state && location.state.initialPhoto, [location.state])

  if (!photos) {
    history.replace('/closet')
    return <div />
  }

  return (
    <div className='imagecarousel-screen-container'>
      <div className='imagecarousel-screen-title' id='teste'>
        <FiArrowLeft onClick={() => history.goBack()}
          size={24} color='var(--primary)' className='imagecarousel-screen-goback' />
        <p>{location.state.title}</p>
      </div>
      <Carousel photos={photos} initialPhoto={initialPhoto} />
    </div>
  )
}

export default withWindowSizeListener(ImageCarousel)



// WEBPACK FOOTER //
// ./src/containers/Closet/ImageCarousel.js